'use strict';

var SetCustomCookie = /** @class */ (function () {
    function SetCustomCookie(options) {
        //需要写入cookie的统计参数
        this.cookieArr = ["MD", "agent", "version", "productname", "UUID"];
        this.options = options;
        this.setDomainCustomCookie();
        this.cookie();
        this.registerChannelCookie();
    }
    /**
     * [setCookie 请求sso.foxitreader.cn]
     *
     * @param   {[type]}  name   [name cookie的key]
     * @param   {[type]}  value  [value cookie的值]
     *
     * @return  {[type]}         [return description]
     */
    SetCustomCookie.prototype.setCookie = function (name, value) {
        var callbackName = "jsonp_callback_".concat(Math.round(100000 * Math.random()));
        var script = document.createElement("script");
        //因服务端无法读取cookie中的version值
        if (name === "version") {
            if (window.readerCookies && window.readerCookies["foxit_version"]) {
                return;
            }
            name = "foxit_version";
        }
        var url = "https://sso.foxitreader.cn/setCookie?name=".concat(name, "&value=").concat(value, "&callback=").concat(callbackName);
        script.src = url;
        document.body.appendChild(script);
    };
    /**
     * [setDomainCookie 写入指定域名cookie ]
     *
     * @param   {[type]}  name   [name cookie的key]
     * @param   {[type]}  value  [value cookie的值]
     *
     * @return  {[type]}         [return description]
     */
    SetCustomCookie.prototype.setDomainCookie = function (name, value) {
        var _a, _b, _c;
        var callbackName = Math.round(100000 * Math.random());
        var script = document.createElement("script");
        //因服务端无法读取cookie中的version值
        if (name === "version") {
            if (((_a = this.options) === null || _a === void 0 ? void 0 : _a.domainCookie) &&
                ((_b = this.options) === null || _b === void 0 ? void 0 : _b.domainCookie["foxit_version"])) {
                return;
            }
            name = "foxit_version";
        }
        var url = "".concat((_c = this.options) === null || _c === void 0 ? void 0 : _c.domainUrl, "?name=").concat(name, "&value=").concat(value, "&jsonpcallback=").concat(callbackName);
        script.src = url;
        document.body.appendChild(script);
    };
    /**
     * [setDomainCustomCookie 额外参数写入cookie]
     *
     * @return  {[type]}  [return description]
     */
    SetCustomCookie.prototype.setDomainCustomCookie = function () {
        var _a, _b, _c;
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.domainCustomParams) {
            var domainCookie = (_b = this.options) === null || _b === void 0 ? void 0 : _b.domainCookie;
            for (var _i = 0, _d = (_c = this.options) === null || _c === void 0 ? void 0 : _c.domainCustomParams; _i < _d.length; _i++) {
                var cookie = _d[_i];
                if (domainCookie && !domainCookie[cookie]) {
                    var value = this.getQueryString(cookie)
                        ? this.getQueryString(cookie)
                        : 0;
                    this.setDomainCookie(cookie, value);
                }
            }
        }
    };
    /**
     * [cookie readerCookies无值写入cookie]
     *
     * @return  {[type]}  [return description]
     */
    SetCustomCookie.prototype.cookie = function () {
        var _a, _b, _c;
        for (var _i = 0, _d = this.cookieArr; _i < _d.length; _i++) {
            var cookie = _d[_i];
            var value = this.getQueryString(cookie) ? this.getQueryString(cookie) : 0;
            if (window.readerCookies && !window.readerCookies[cookie]) {
                this.setCookie(cookie, value);
            }
            if (((_a = this.options) === null || _a === void 0 ? void 0 : _a.domainCookie) && !((_b = this.options) === null || _b === void 0 ? void 0 : _b.domainCookie[cookie])) {
                if ((_c = this.options) === null || _c === void 0 ? void 0 : _c.domainUrl) {
                    this.setDomainCookie(cookie, value);
                }
            }
        }
    };
    /**
     * [registerChannelCookie 注册渠道统计]
     * 优先级 product_name>productname>webProductName
     * @return  {[type]}  [return description]
     */
    SetCustomCookie.prototype.registerChannelCookie = function () {
        var _a, _b;
        if (this.getQueryString("product_name")) {
            this.setCookie("product_name", this.getQueryString("product_name"));
        }
        else if (this.getQueryString("productname")) {
            this.setCookie("product_name", this.getQueryString("productname"));
        }
        else if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.webProductName) {
            this.setCookie("product_name", this.options.webProductName);
        }
        else if (!((_b = window.readerCookies) === null || _b === void 0 ? void 0 : _b["product_name"])) {
            this.setCookie("product_name", "0");
        }
    };
    /**
     * [getQueryString 获取url参数]
     *
     * @param   {[type]}  name  [name 参数]
     *
     * @return  {[type]}        [return description]
     */
    SetCustomCookie.prototype.getQueryString = function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var lower = new RegExp("(^|&)" + name.toLowerCase() + "=([^&]*)(&|$)");
        var upper = new RegExp("(^|&)" + name.toUpperCase() + "=([^&]*)(&|$)");
        var r;
        if (window.location.search.substr(1).match(reg)) {
            r = window.location.search.substr(1).match(reg);
        }
        else if (window.location.search.substr(1).match(lower)) {
            r = window.location.search.substr(1).match(lower);
        }
        else {
            r = window.location.search.substr(1).match(upper);
        }
        if (r != null)
            return unescape(r[2]);
        return 0;
    };
    return SetCustomCookie;
}());

module.exports = SetCustomCookie;
